module.exports = __webpack_public_path__ + "img/sl.d3924268.svg";